export const asArray = <T>(value: unknown): T[] => (Array.isArray(value) ? (value as T[]) : [])

export const hasMeaningfulString = (value: unknown): boolean => {
  if (value == null) return false
  return String(value).trim() !== ''
}

export const hasValidString = hasMeaningfulString

export const contactTelHref = (value: unknown): string => {
  const digits = String(value ?? '').replace(/[^\d+]/g, '')
  return digits ? `tel:${digits}` : '#'
}

export const contactSmsHref = (value: unknown): string => {
  const digits = String(value ?? '').replace(/[^\d+]/g, '')
  return digits ? `sms:${digits}` : '#'
}

export const contactMailHref = (value: unknown): string => {
  const email = String(value ?? '').trim()
  return email ? `mailto:${email}` : '#'
}

export const contactLabel = (text: unknown, value: unknown): string => {
  const label = text != null ? String(text).trim() : ''
  if (label) return label
  return value != null ? String(value) : ''
}

export const internationalPhoneDisplayText = (contact: Record<string, unknown> | null | undefined): unknown =>
  contact?.InternationalPhoneText ?? contact?.internationalPhoneText

export const smsPhoneDisplayText = (contact: Record<string, unknown> | null | undefined): unknown =>
  contact?.SMSPhoneText ?? contact?.smsPhoneText

export const shouldRenderContactValue = (flag: unknown, value: unknown): boolean =>
  flag !== false && hasMeaningfulString(value)

export const isLoginSeasonalPath = (link: unknown): boolean =>
  link != null && String(link).includes('seasonal-app/login')
